import type { EnhancedCampaign, EnhancedCategory, EnhancedGame, GameProvider } from '~/components/casino-shared/types';
import { CarouselItem, GameLiveData, ProviderGameStatesMap } from '../types';

import {
	FETCH_CASINO_ALL_GAMES_START,
	HYDRATE_LIVE_CASINO_GAMES,
	INVALIDATE_LIVE_CASINO_DATA,
	LIVE_CASINO_FEED_SOCKET_CLOSE_CONNECTION,
	LIVE_CASINO_FEED_SOCKET_ON_CONNECTION_OPEN,
	LIVE_CASINO_FEED_SOCKET_ON_MESSAGE,
	LIVE_CASINO_FEED_SOCKET_SET_RETRY_TIMEOUT,
	SET_BANNER_AUTH,
	SET_CAROUSEL_ITEMS,
	SET_LIVE_CASINO_DATA
} from './action-names';

export const EXPLORE_LIVE_CASINO_SUCCESS = 'live_success';
export const EXPLORE_LIVE_CASINO_LOADING = 'live_loading';
export const EXPLORE_LIVE_CASINO_ERROR = 'live_error';

export type State = {
	loading: boolean;
	hydrated: boolean;
	wasAuthenticated: boolean;
	timeout: null;
	liveCasinoData: { provider: string; gameStates: Record<string, GameLiveData> }[];
	carouselItems: null | CarouselItem[];
	bannerAuth: boolean;
	games: Record<string, EnhancedGame>;
	gameNamesByIdx: string[];
	gameCodesByProviderCode: Record<string, string[]>;
	gameCodesBySubProviderCode: Record<string, string[]>;
	gameCodesByIdx: string[];
	campaigns: EnhancedCampaign[];
	exploreCategories: EnhancedCategory[];
	exploreLiveCasinoStatus:
		| typeof EXPLORE_LIVE_CASINO_SUCCESS
		| typeof EXPLORE_LIVE_CASINO_LOADING
		| typeof EXPLORE_LIVE_CASINO_ERROR
		| null;
	initialized?: boolean;
	providers: Record<string, GameProvider>;
	subProviders: Record<string, GameProvider>;
};

export type Actions =
	| {
			type: typeof SET_LIVE_CASINO_DATA;
			payload: {
				provider: string;
				gameStates: Record<string, GameLiveData>;
			}[];
	  }
	| { type: typeof SET_CAROUSEL_ITEMS; payload: { items: CarouselItem[] } }
	| { type: typeof SET_BANNER_AUTH; payload: boolean }
	| { type: typeof FETCH_CASINO_ALL_GAMES_START }
	| {
			type: typeof HYDRATE_LIVE_CASINO_GAMES;
			payload: {
				games: State['games'];
				gameCodesByIdx: State['gameCodesByIdx'];
				gameNamesByIdx: State['gameNamesByIdx'];
				gameCodesByProviderCode: State['gameCodesByProviderCode'];
				gameCodesBySubProviderCode: State['gameCodesBySubProviderCode'];
				providers: State['providers'];
				campaigns: State['campaigns'];
				exploreCategories: State['exploreCategories'];
				hydrated: true;
				loading: false;
				wasAuthenticated: boolean;
				exploreLiveCasinoStatus: State['exploreLiveCasinoStatus'];
			};
	  }
	| { type: typeof INVALIDATE_LIVE_CASINO_DATA }
	| { type: typeof LIVE_CASINO_FEED_SOCKET_ON_CONNECTION_OPEN }
	| {
			type: typeof LIVE_CASINO_FEED_SOCKET_SET_RETRY_TIMEOUT;
			payload: { retryTimeout: NodeJS.Timeout | null; timeoutType: string };
	  }
	| {
			type: typeof LIVE_CASINO_FEED_SOCKET_ON_MESSAGE;
			payload: { providerGameStatesMap: ProviderGameStatesMap };
	  }
	| { type: typeof LIVE_CASINO_FEED_SOCKET_CLOSE_CONNECTION };
